import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import "@/App.css";
import ScrollToTop from "@/components/ScrollToTop";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import LegalPage from "@/components/LegalPage";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import {
  I18nProvider,
  SUPPORTED_LANGS,
  DEFAULT_LANG,
  useI18n,
} from "@/i18n/I18nContext";
import { initConsentDefaults } from "@/lib/consent";

function LangGate({ children }) {
  const { lang } = useParams();
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return <I18nProvider lang={lang}>{children}</I18nProvider>;
}

function TitleSync() {
  const { t, lang } = useI18n();
  useEffect(() => {
    document.title = t("meta.title");
    document.documentElement.lang = lang === "ec" ? "es-EC" : "en";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [t, lang]);
  return null;
}

function LangRoot() {
  return (
    <LangGate>
      <TitleSync />
      <SiteLayout />
    </LangGate>
  );
}

function App() {
  useEffect(() => {
    initConsentDefaults();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LangRoot />}>
          <Route index element={<Home />} />
          <Route path="privacy" element={<LegalPage contentKey="privacy" />} />
          <Route path="cookies" element={<LegalPage contentKey="cookies" />} />
          <Route path="terms" element={<LegalPage contentKey="terms" />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
